/**
 * @module util/portPicker/pickedLocation
 * Normalized "picked place" value attached to a search side. Travels alongside the
 * existing `selectedPort` as an OPTIONAL field (backward compatible — old backend
 * ignores it). PRD §6.4.
 */
import { toCoord } from './geo';
import { PlaceKind } from './constants';

/**
 * @param {{kind,label,lat?,lng?,country?,countryId?,placeId?,portId?,code?}} input
 * @returns {{kind,label,lat,lng,country,countryId,placeId,portId,code}}
 */
export const makePickedLocation = (input = {}) => ({
  kind: input.kind || PlaceKind.GEO_PLACE,
  label: input.label || '',
  lat: toCoord(input.lat),
  lng: toCoord(input.lng),
  country: input.country ?? null,
  countryId: input.countryId ?? null,
  placeId: input.placeId ?? null, // Google place_id (for an address) — else null
  portId: input.portId ?? null, // set when kind is an exact PF SEAPORT/AIRPORT
  code: input.code ?? null, // UN/LOCODE (seaport) or IATA (airport) when known
});

/** A pick is an exact PF port/airport (no nearest-port expansion needed). */
export const isExactPort = (picked) =>
  picked != null && (picked.kind === PlaceKind.SEAPORT || picked.kind === PlaceKind.AIRPORT);
